import { TYPES } from "./draft_bailiff.type";

const initState = {
  draftBailiffAll: null,
  draftBailiffOpenAdd: false,
  draftBailiffOpenEdit: false,
  draftBailiffSelected: null,
  draftBailiffSearch: "",
  //
  draftBailiffDetail: null,
  draftBailiffOpenForward: false,
  // phiên bản merge.
  draftBailiffMerge: null,
  draftBailiffSpeakers: [],
};

const draftBailiffReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SET_DRAFT_BAILIFF_OPEN_FORWARD:
      return {
        ...state,
        draftBailiffOpenForward: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_DETAIL:
      return {
        ...state,
        draftBailiffDetail: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_ALL:
      return {
        ...state,
        draftBailiffAll: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_OPEN_ADD:
      return {
        ...state,
        draftBailiffOpenAdd: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_OPEN_EDIT:
      return {
        ...state,
        draftBailiffOpenEdit: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_SELECTED:
      return {
        ...state,
        draftBailiffSelected: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_SEARCH:
      return {
        ...state,
        draftBailiffSearch: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_MERGE:
      return {
        ...state,
        draftBailiffMerge: payload,
      };

    case TYPES.SET_DRAFT_BAILIFF_SPEAKERS:
      return {
        ...state,
        draftBailiffSpeakers: payload,
      };

    default:
      return state;
  }
};

export default draftBailiffReducer;
